module.exports = __webpack_public_path__ + "static/media/wallet_icon.0754c7e0.svg";